import BaseService from '../BaseService.js'

export default class MonitoringService extends BaseService {

  constructor() {
    super('admin/monitoring')
  }

  async getLastSchedulerRun() {
    await this.getBackendListUrl('lastSchedulerRun').then(url => this.serviceurl = url)
    return this.checkError(
      fetch(`${this.serviceurl}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }
}
